export default "__VITE_ASSET__Nla7QYqF__"